import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import dynamicsTabs from '../tabs/dynamicsTabs'

/**
 * Login a user by reading their aid and uid from their location
 *
 * This component follows the same API as LoginFrame, but is insecure
 * because it trusts whatever URL the user has in their location bar.
 *
 * This component makes an API request to initialize the session and
 * retrieve any required data.
 *
 * TODO Persist auth on screen refresh
 * TODO Use proper oauth for integrations which currently rely on URL
 */
class InsecurePortalLogin extends React.Component {
  static propTypes = {
    // Called if the aid and uid are successfully parsed from the URL
    onLogin: PropTypes.func.isRequired,
    // Called if the aid and uid could not be parsed from the URL
    onError: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { history, onError, onLogin } = this.props;

    // Parse the org_id and user_id out of the URL
    // URL format: /_dynamics/portal/{org_id}/{user_id}
    const match = history.location.pathname.match(/^\/_dynamics\/portal\/([^/]+)\/([^/]+)$/);
    if (match) {
      const [_, orgId, userId] = match;
      onLogin({
        org: {
          name: orgId,  // TODO fetch org name from backend
          id: orgId,
        },
        user: {
          name: userId,  // TODO fetch user name from backend
          id: userId,
        },
        availableTabs: dynamicsTabs(orgId, userId),
      });
    } else {
      onError();  // TODO pass error message and handle in parent
    }
  }

  render() {
    // We don't need to render anything since we will either call
    // onLogin or onError passed from the parent component
    return null;
  }
}

export default withRouter(InsecurePortalLogin);
